import { parseDateFromBackendValue } from "@/utils/dateFormatter";

export const isPriceHistoryRowInSeason = (row, season) => {
	if (!row?.created_at || !season?.start_date || !season?.end_date) {
		return false;
	}

	const rowDate = parseDateFromBackendValue(row.created_at);
	const seasonStart = parseDateFromBackendValue(season.start_date);
	const seasonEnd = parseDateFromBackendValue(season.end_date);

	if (!rowDate || !seasonStart || !seasonEnd) {
		return false;
	}

	return rowDate >= seasonStart && rowDate < seasonEnd;
};

export const filterPriceHistoryBySeason = (rows, season, estateParentId) => {
	return rows
		.filter((row) => String(row.estate_parent_id) === String(estateParentId))
		.filter((row) => isPriceHistoryRowInSeason(row, season))
		.sort((leftRow, rightRow) => {
			const leftDate = parseDateFromBackendValue(leftRow.created_at);
			const rightDate = parseDateFromBackendValue(rightRow.created_at);
			if (!leftDate || !rightDate) {
				return 0;
			}
			return leftDate.getTime() - rightDate.getTime();
		});
};

export const computeSeasonAveragePrice = (rows) => {
	const validRows = rows.filter((row) => !row.isEmptySeason && row.price != null);
	if (!validRows.length) {
		return null;
	}

	let weightedSum = 0;
	let totalWeight = 0;

	for (const row of validRows) {
		const weight = Number(row.stock) > 0 ? Number(row.stock) : 1;
		weightedSum += Number(row.price) * weight;
		totalWeight += weight;
	}

	return totalWeight > 0 ? weightedSum / totalWeight : null;
};
